import { useSnackbar } from "notistack";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ReactGA from "react-ga4";
// import Spinner from "../components/Spinner";

// const EditProduct = () => {

const AcessarLoja = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "tela_de_login_atleta",
    });
  }, []);

  const handleAcesso = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/auth/acesso`,
        { password: password.toUpperCase() }
        // config
      );

      localStorage.setItem("user", JSON.stringify(response.data.user));
      localStorage.setItem("scouterToken", response.data.token);
      navigate("/games");
      // }
    } catch (error) {
      enqueueSnackbar("Código inválido", {
        variant: "warning",
      });
    }
  };

  //   const [loading, setLoading] = useState(false);
  return (
    <div className="p-6 bg-base-100 flex justify-center items-center mt-20">
      <div className="container max-w-lg shadow-lg rounded-lg p-5 bg-base-100">
        <div className="justify-center flex mt-4 flex-col">
          <h1 className="text-3xl font-semibold text-center">Acesso à loja</h1>
          <form
            className="w-full mx-auto max-w-xs mt-12"
            onSubmit={handleAcesso}
          >
            <div className="my-2">
              <label htmlFor="mensagem" className="block text-md  mb-2">
                Digite o código que o Adauto te passou.
              </label>

              <input
                id="password"
                type="password"
                value={password}
                placeholder="Código"
                onChange={(e) => setPassword(e.target.value)}
                className="border border-base-300 px-4 py-2 w-full rounded-md"
                required
              />

              <button
                type="submit"
                className="w-full bg-blue-500
                              hover:bg-blue-800 text-white py-2 px-4 rounded-md my-12"
              >
                Entrar
              </button>

              <Link to="/" className="btn mt-5">
                Voltar
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AcessarLoja;
